require('./src/loggly.tracker');
module.exports._LTracker = window._LTracker;
module.exports.LogglyTracker = window.LogglyTracker;


//////////////////
// WEBPACK FOOTER
// ./~/loggly-jslogger/index.js
// module id = 2220
// module chunks = 0